/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'right-arrow': {
    width: 16,
    height: 16,
    viewBox: '0 0 34 34',
    data: '<path pid="0" d="M30.1 17.9H1.5c-.5 0-1-.4-1-1s.4-1 1-1H30l-8.6-8.8c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l10.3 10.5c.4.4.4.9.1 1.3 0 .1-.1.2-.2.2L22.7 28.2c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l8.8-8.9z"/>'
  }
})
